<template>
  <div class="content">
    <div class="main">
      <Row>
      <Col span="5"></Col>
      <Col span="24" :md="12">
        <Form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <FormItem  label="项目名(英文)" prop="project">
            <Input   v-model="formItem.project"  disabled></Input>
          </FormItem>
          <form-item label="代码管理" prop="version_control">
             <i-select v-model="formItem.version_control" @on-change="onSelectGitOrSvn">
                  <Option value="svn">SVN</Option>
                  <Option value="git">Git</Option>
             </i-select>
          </form-item>
          <form-item label="项目所在组" prop="group" v-show="group_visible">
             <i-select v-model="formItem.group">
              <i-option v-for="item in gitlabGroupOptions" :value="item.name" :key="item.name" :label="item.name"></i-option>
             </i-select>
          </form-item>
          <form-item label="代码服务器" prop="host" >
            <i-input  v-model="formItem.host" placeholder="请输入项目所在服务器的IP"></i-input>
          </form-item>
          <FormItem  label="代码地址" prop="address">
            <Input   v-model="formItem.address"></Input>
          </FormItem>
          <FormItem  label="Jenkins地址" prop="jenkins">
            <Input   v-model="formItem.jenkins"></Input>
          </FormItem>
        <FormItem>
            <Button type="primary" @click="doSubmit('formItem')">修改</Button>
        </FormItem>
    </Form>
    </Col>
    </Row>
</div></div>
</template>
<script>
import { getGitlabGroupList } from '@/api/gitlab'
import { fetchProjectCodeData, editProjectCodeData } from '@/api/project'
export default {
  name: 'CodeForm',
  components: {
  },
  props:
    {
      'id': Number,
      'type': {
        type: String,
        required: true
      }
    },
  data () {
    const validateGroup = (rule, value, callback) => {
      if (!value && this.group_visible) {
        callback(new Error('项目所在组不能为空 !'))
      } else {
        callback()
      }
    }
    return {
      id_own: null,
      gitlabGroupOptions: [],
      group_visible: true,
      formItem: {
        project: '',
        version_control: '',
        group: '',
        host: '',
        address: '',
        jenkins: ''
      },
      ruleValidate: {
        group: [
          { validator: validateGroup, trigger: 'change' }
        ],
        host: [{ required: true, message: '代码服务器不能为空 !', trigger: 'blur' }]
      }
    }
  },
  watch: {
    id () {
      this.id_own = this.id
      // 取Code info
      if (this.id_own) {
        this.fetchProjectCodeData(this.id_own)
      }
    }
  },
  methods: {
    doSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          editProjectCodeData(this.id_own, this.formItem).then(res => {
            if (res.data.project) {
              // this.$router.push({name: 'ProjectDetail', query: {id: this.id_own}})
              this.$Message.success('修改成功')
            } else {
              this.$Message.error(res.data)
            }
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
      })
    },
    fetchAllGitlabGroupData () {
      getGitlabGroupList().then(res => {
        this.gitlabGroupOptions = res.data
      })
    },
    onSelectGitOrSvn (value) {
      if (value === 'git') {
        this.group_visible = true
      } else {
        this.group_visible = false
      }
    },
    fetchProjectCodeData (id) {
      fetchProjectCodeData(id).then(res => {
        this.formItem.project = res.data.project
        this.formItem.version_control = res.data.version_control
        this.formItem.group = res.data.group
        this.formItem.host = res.data.host
        this.formItem.address = res.data.address
        this.formItem.jenkins = res.data.jenkins
        if (this.formItem.version_control === 'svn') {
          this.group_visible = false
        }
      })
    }
  },
  mounted: function () {
    this.fetchAllGitlabGroupData()
  }
}
</script>
